"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootContainer = exports.ButtonSave = exports.ButtonCancel = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const ButtonSave = exports.ButtonSave = (0, _mui.styled)(_components.Button)(({
  theme,
  ownerState
}) => ({
  width: '100%',
  marginTop: theme.spacing(3),
  color: `${theme.palette.default.contrastText} !important`,
  ...(ownerState.disabled && {
    color: `${theme.palette.grey[500]} !important`
  })
}));
const ButtonCancel = exports.ButtonCancel = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  width: '100%',
  marginTop: theme.spacing(3)
}));
const RootContainer = exports.RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));
//# sourceMappingURL=ActionButtonStyled.js.map